import * as m from "./../../../dist/es2015/plugins/exporting.js";
export const am5plugins_exporting = m;